import { useTheme } from "@emotion/react";
import {
  AccessTimeOutlined,
  Check,
  TimelineOutlined,
} from "@mui/icons-material";
import { Chip, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import useStyles from "./styles";

// Importações do Timeline
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";

export default function TimelineComponent(params) {
  const { ticketDetails = {}, isOsIxc = false } = params;
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  const theme = useTheme();
  const styles = useStyles(theme);
  const colors = Object.keys(theme.palette.colors)?.filter(
    (color) => color !== "white" && color !== "black",
  );
  function adicionarCores(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }
  const fluxoAtendimentoColor = adicionarCores(
    ticketDetails?.allEtapasFluxoAtendimentos,
  );
  const fluxoAtendimentoColorIxc = {
    Novo: theme.palette.colors.blue.dark,
    Pendente: theme.palette.cardTrafficData.paperColor.outputData,
    "Em progresso": theme.palette.cardTrafficData.paperColor.inputData,
  };
  const fluxoAtendimentoColorOsIxc = {
    Aberto: theme.palette.cardTrafficData.paperColor.outputData,
    Encaminhado: theme.palette.cardTrafficData.paperColor.speeData,
    Agendado: theme.palette.cardTrafficData.paperColor.inputData,
    Reagendar: theme.palette.colors.pink.dark,
    "Em Análise": theme.palette.colors.orange.darker,
    Assumido: theme.palette.colors.blue.dark,
    "Em execução": theme.palette.colors.yellow.darker,
    "Deslocamento:": theme.palette.colors.purple.dark,
  };

  const selectColorsTypeErp = (descricaoEtapa) => {
    switch (erp) {
      case "HUBSOFT":
        return theme.palette.colors[fluxoAtendimentoColor[descricaoEtapa]]
          .medium;

      case "IXC":
        return isOsIxc
          ? fluxoAtendimentoColorOsIxc[descricaoEtapa]
          : fluxoAtendimentoColorIxc[descricaoEtapa];
      default:
        return null;
    }
  };

  // Função auxiliar para formatar minutos em texto legível (opcional)
  const formatDuration = (minutes) => {
    if (!minutes) return "Menos de 1 minuto";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0) return `${hours}h ${mins}min`;
    return `${mins} min`;
  };

  const formatTotalTime = (historyArray) => {
    // 1. Soma todos os minutos do array
    const totalMinutes =
      historyArray?.reduce((acc, item) => acc + (item.timeEtapa || 0), 0) || 0;

    if (totalMinutes === 0) return "0 min";

    // Constantes de conversão
    const MIN_IN_HOUR = 60;
    const MIN_IN_DAY = 1440; // 60 * 24
    const MIN_IN_YEAR = 525600; // 1440 * 365

    let remaining = totalMinutes;

    const years = Math.floor(remaining / MIN_IN_YEAR);
    remaining %= MIN_IN_YEAR;

    const days = Math.floor(remaining / MIN_IN_DAY);
    remaining %= MIN_IN_DAY;

    const hours = Math.floor(remaining / MIN_IN_HOUR);
    const minutes = remaining % MIN_IN_HOUR;

    // 2. Monta a string de forma amigável
    const parts = [];
    if (years > 0) parts.push(`${years} ${years === 1 ? "ano" : "anos"}`);
    if (days > 0) parts.push(`${days} ${days === 1 ? "dia" : "dias"}`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || parts.length === 0) parts.push(`${minutes}min`);

    return parts.join(" ");
  };

  return (
    <Box sx={{ height: "85%", overflowY: "auto" }}>
      <Box sx={styles.boxEdit}>
        <Typography sx={styles.titleDescription}>
          <TimelineOutlined sx={{ fontSize: "18px", mr: 1 }} />
          Histórico
        </Typography>
      </Box>
      <Box sx={styles.containerBodyModal}>
        <Box sx={styles.boxBodyModal}>
          <Paper
            variant="outlined"
            elevation={0}
            sx={{ ...styles.containerPaperModal, padding: 2 }}
          >
            <Box sx={styles.boxTimeline}>
              <Box sx={styles.boxChip}>
                <Chip
                  icon={
                    <AccessTimeOutlined sx={{ fontSize: "16px !important" }} />
                  }
                  label={
                    <Typography variant="caption" sx={{ fontWeight: 600 }}>
                      Tempo total:{" "}
                      {formatTotalTime(
                        ticketDetails?.historicoFluxoAtendimento,
                      )}
                    </Typography>
                  }
                  variant="outlined"
                  sx={styles.chipTime}
                />
              </Box>
              {ticketDetails?.historicoFluxoAtendimento?.length > 0 ? (
                <Timeline position="alternate">
                  {ticketDetails?.historicoFluxoAtendimento?.map(
                    (item, index) => {
                      const isLast =
                        index ===
                        ticketDetails?.historicoFluxoAtendimento?.length - 1;

                      // Identifica se o item está na esquerda (índices ímpares: 1, 3, 5...)
                      // Na Timeline alternate do MUI: Index 0 = Direita, Index 1 = Esquerda.
                      const isLeftSide = index % 2 !== 0;

                      return (
                        <TimelineItem key={item.id}>
                          <TimelineSeparator>
                            <TimelineDot
                              sx={{
                                bgcolor:
                                  selectColorsTypeErp(item?.descricaoEtapa) ||
                                  "",
                                borderColor:
                                  selectColorsTypeErp(item?.descricaoEtapa) ||
                                  "",
                              }}
                              variant="filled"
                            />
                            {(!isLast ||
                              (isLast && ticketDetails?.status?.id === 3)) && (
                              <TimelineConnector />
                            )}
                          </TimelineSeparator>

                          <TimelineContent sx={{ py: "12px", px: 2 }}>
                            <Paper
                              elevation={0}
                              sx={{
                                ...styles.paperTimeline,

                                ml: isLeftSide ? "auto" : 0,

                                textAlign: isLeftSide ? "right" : "left",
                              }}
                            >
                              <Box
                                sx={{
                                  ...styles.boxColor,
                                  left: !isLeftSide && 0,
                                  right: isLeftSide && 0,
                                  backgroundColor:
                                    selectColorsTypeErp(item?.descricaoEtapa) ||
                                    "",
                                }}
                              />
                              <Box sx={{ margin: "0 10px" }}>
                                <Typography
                                  variant="subtitle2"
                                  component="span"
                                  sx={{
                                    fontWeight: "bold",
                                    display: "block",
                                    mb: 1,
                                  }}
                                >
                                  {item.descricaoEtapa}
                                </Typography>

                                <Typography sx={{ fontSize: "12px" }}>
                                  <Box
                                    component="span"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    De:
                                  </Box>{" "}
                                  {dayjs(item.initialDate).format(
                                    "DD/MM/YYYY [às] HH:mm",
                                  )}
                                </Typography>

                                <Typography sx={{ fontSize: "12px" }}>
                                  <Box
                                    component="span"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    Até:
                                  </Box>{" "}
                                  {isLast && ticketDetails?.status?.id !== 3
                                    ? "Atualmente"
                                    : dayjs(item.finalDate).format(
                                        "DD/MM/YYYY [às] HH:mm",
                                      )}
                                </Typography>

                                <Typography sx={{ fontSize: "12px" }}>
                                  <Box
                                    component="span"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    Tempo na etapa:
                                  </Box>{" "}
                                  {formatDuration(item.timeEtapa)}
                                </Typography>
                              </Box>
                            </Paper>
                          </TimelineContent>
                        </TimelineItem>
                      );
                    },
                  )}

                  {ticketDetails?.status?.id === 3 && (
                    <TimelineItem>
                      <TimelineSeparator>
                        <TimelineDot color="primary">
                          <Check />
                        </TimelineDot>
                      </TimelineSeparator>

                      <TimelineContent sx={{ py: "12px", px: 2 }}>
                        <Paper
                          elevation={0}
                          sx={{
                            ...styles.paperTimeline,

                            ml:
                              ticketDetails?.historicoFluxoAtendimento?.length %
                                2 !==
                              0
                                ? "auto"
                                : 0,

                            textAlign:
                              ticketDetails?.historicoFluxoAtendimento?.length %
                                2 !==
                              0
                                ? "right"
                                : "left",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            component="span"
                            sx={{ fontWeight: "bold" }}
                          >
                            RESOLVIDO
                          </Typography>

                          <Typography sx={{ fontSize: "12px" }}>
                            <Box component="span" sx={{ fontWeight: "bold" }}>
                              Resolvido por:
                            </Box>{" "}
                            {ticketDetails?.usuario_fechamento}
                          </Typography>

                          <Typography sx={{ fontSize: "12px" }}>
                            <Box component="span" sx={{ fontWeight: "bold" }}>
                              Em:
                            </Box>{" "}
                            {dayjs(ticketDetails.data_fechamento).format(
                              "DD/MM/YYYY [às] HH:mm",
                            )}
                          </Typography>
                        </Paper>
                      </TimelineContent>
                    </TimelineItem>
                  )}
                </Timeline>
              ) : (
                <Typography variant="body2" sx={{ p: 2, textAlign: "center" }}>
                  Nenhum histórico encontrado.
                </Typography>
              )}
            </Box>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}
